module.exports = __webpack_public_path__ + "static/media/033.213a1b56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/033.jpg
// module id = 379
// module chunks = 0